// extracted by mini-css-extract-plugin
module.exports = {"container":"_page-references_container__HRB8_","references":"_page-references_references__jOGDc","header":"_page-references_header__Nc4P8"};